<template>
<div>
  <router-link class="btn btn-primary" :to="{path:'/create-vip'}">开通会员</router-link>
  <div class="table-responsive" style="margin-top:20px;">
    <table class="table">
      <thead>
        <tr>
          <th>序号</th>
          <th>姓名</th>
          <th>电话</th>
          <th>余额</th>
          <th>性别</th>
          <!-- <th>时间</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in list.items" :key="index" @click="goToVipView(item)">
          <td>{{index+1}}</td>
          <td><a href="javascript:;" @click="goToVipView(item)">{{item.profile.name}}</a></td>
          <td>{{item.phone}}</td>
          <td>{{item.profile.balance}}</td>
          <td>{{item.profile.sex}}</td>
          <!-- <td>{{item.profile.createAt|date}}</td> -->
        </tr>
      </tbody>
    </table>
  </div>
  <pagination style="text-align:center;" v-model="list.pageIndex" :total-page="list.totalPage"/>
</div>
  
</template>

<script>
import * as TYPES from '../store/types'
import apiClient from '../api'

export default {
  data() {
    return {
      list: {
        items: []
      }
    }
  },
  created() {
    apiClient.DO_GET_ALL_USERS()
    .then(res => {
      if (res.data.ok) {
        this.list = res.data.data
      }
    })
  },
  methods: {
    goToVipView(item) {
      this.$store.dispatch(TYPES.ON_USER_VIEW, item)
      this.$router.push('/vip/' + item.profile.phone)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Vips.vue